/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { MarketAsset } from 'src/config';

import heroSm from 'src/config/medicaid/asset/landing/hero-sm-min.png';
import heroSmWebp from 'src/config/medicaid/asset/landing/hero-sm-min.webp';

import heroMd from 'src/config/medicaid/asset/landing/hero-md-min.png';
import heroMdWebp from 'src/config/medicaid/asset/landing/hero-md-min.webp';

import heroLg from 'src/config/medicaid/asset/landing/hero-lg-min.png';
import heroLgWebp from 'src/config/medicaid/asset/landing/hero-lg-min.webp';

import testimonial from 'src/config/medicaid/asset/landing/testimonial-min.png';
import testimonialWebp from 'src/config/medicaid/asset/landing/testimonial-min.webp';

import valuesBlob from 'src/config/medicaid/asset/landing/values-blob-min.svg';

import valuesSm from 'src/config/medicaid/asset/landing/values-sm-min.png';
import valuesSmWebp from 'src/config/medicaid/asset/landing/values-sm-min.webp';

import valuesMd from 'src/config/medicaid/asset/landing/values-md-min.png';
import valuesMdWebp from 'src/config/medicaid/asset/landing/values-md-min.webp';

import valuesLg from 'src/config/medicaid/asset/landing/values-lg-min.png';
import valuesLgWebp from 'src/config/medicaid/asset/landing/values-lg-min.webp';

import expect1lg_circle from 'src/config/medicaid/asset/landing/wte-1-us-lg-min.png';
import expect1lg_circle_webp from 'src/config/medicaid/asset/landing/wte-1-us-lg-min.webp';

import expect1sm_circle from 'src/config/medicaid/asset/landing/wte-1-us-sm-min.png';
import expect1sm_circle_webp from 'src/config/medicaid/asset/landing/wte-1-us-sm-min.webp';

import expect2lg_circle from 'src/config/medicaid/asset/landing/wte-2-us-lg-min.png';
import expect2lg_circle_webp from 'src/config/medicaid/asset/landing/wte-2-us-lg-min.webp';

import expect2sm_circle from 'src/config/medicaid/asset/landing/wte-2-us-sm-min.png';
import expect2sm_circle_webp from 'src/config/medicaid/asset/landing/wte-2-us-sm-min.webp';

import expect3lg_circle from 'src/config/medicaid/asset/landing/wte-3-us-lg-min.png';
import expect3lg_circle_webp from 'src/config/medicaid/asset/landing/wte-3-us-lg-min.webp';

import expect3sm_circle from 'src/config/medicaid/asset/landing/wte-3-us-sm-min.png';
import expect3sm_circle_webp from 'src/config/medicaid/asset/landing/wte-3-us-sm-min.webp';

const asset: MarketAsset = {
  landing: {
    heroSm,
    heroSmWebp,
    heroMd,
    heroMdWebp,
    heroLg,
    heroLgWebp,
    testimonial,
    testimonialWebp,
    valuesBlob,
    valuesSm,
    valuesSmWebp,
    valuesMd,
    valuesMdWebp,
    valuesLg,
    valuesLgWebp,
    expect1lg: expect1lg_circle,
    expect1lgWebp: expect1lg_circle_webp,
    expect1sm: expect1sm_circle,
    expect1smWebp: expect1sm_circle_webp,
    expect2lg: expect2lg_circle,
    expect2lgWebp: expect2lg_circle_webp,
    expect2sm: expect2sm_circle,
    expect2smWebp: expect2sm_circle_webp,
    expect3lg: expect3lg_circle,
    expect3lgWebp: expect3lg_circle_webp,
    expect3sm: expect3sm_circle,
    expect3smWebp: expect3sm_circle_webp
  }
};

export default asset;
